import { render, staticRenderFns } from "./orderStatistics.vue?vue&type=template&id=6ed1aeb5&scoped=true&"
import script from "./orderStatistics.vue?vue&type=script&lang=ts&"
export * from "./orderStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed1aeb5",
  null
  
)

export default component.exports